import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const Play = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          ref={ref}
          {...props}
        >
          <path d="M5 4L16 10L5 16V4Z" fill="currentcolor" />
        </svg>
      </Icon>
    );
  },
);

Play.displayName = "Play";
